import React from "react";

const defaultProps = {
  showDivider: true,
};
export default function ModalDividerLine(props = defaultProps) {
  if (props.showDivider === true) {
    return <div className="generic-modal-divider"></div>;
  }
  return null;
}
